import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Ratios } from "../../../Constants/Constants";
import AspectRatios from "./AspectRatios";
import CustomRatio from "./CustomRatio";
import DefaultRatio from "./DefaultRatio";

const RatiosContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Ratios} parent={BonusUi} />
      <Container fluid>
        <Row>
          <AspectRatios />
          <CustomRatio />
          <DefaultRatio />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RatiosContainer;
